export const h = {
	quantity: "재고",
	brand: "브랜드",
	sku: "SKU",
	model: "모델",
	addCart: "장바구니 넣기",
	buyNow: "바로 구매하기",
	productDetail: "상품상세",
	attribute: "속성",
	quantityExits: "재고 있음",
	quantityNone: "품절",

	// 账单页面
	email: "이메일",
	errorEmail: "올바른 이메일을 입력하세요.",
	contact: '연락처',
	sippingAddress: '배송 주소',
	name: "이름",
	nameError: "이름을 입력하세요",
	address1: "주소1",
	address1Error: "주소를 입력하세요1",

	address2: "주소2",
	emailCode: "우편번호",

	phone: "휴대폰 번호",
	city: "도시",
	cityError: "도시를 입력하세요",
	country: "국가",
	countryError: "국가를 입력하세요",
	province: "주",
	provinceError: "주를 입력하세요",
	payWay: "지불 방법",
	sendWay: "배송 방법",
	loginText: "로그인 / 등록",
	cartNum: "장바구니 총 수",
	orderRemarks: "주문 비고",
	discountCode: "할인 코드를 입력하세요",
	apply: "사용",
	submitOrder: "주문하기",

	classify: "분류",
	price: "가격",
	allNum: "총 수량",
	defaultTit: "기본값",
	salesLowToHigh: "판매량 (낮음 → 높음)",
	salesHighToLow: "판매량 (높음 → 낮음)",
	nameAtoZ: "이름 (A → Z)",
	nameZtoA: "이름 (Z → A)",
	priceLowtoHeight: "가격 (낮음 → 높음)",
	priceHeighttoLow: "가격 (높음 → 낮음)",
	selectClassfiy: "분류 선택",
	goodCart: "장바구니",
	checkout: "결제",
	pay: "결제",
	goods: "상품",
	num: "수량",
	total: "소계",
	action: "작업",
	del: "삭제",
	priceTotal: "상품 총합",
	all: "전체",
	selectd: "선택됨",
	goCheckout: "결제 하러 가기",
	linkGoods: "연관 상품",
	noData: "데이터 없음",
	myOrder: "내 주문",
	changeUserInfo: "개인정보 수정",
	changePassword: "비밀번호 변경",
	myAddress: "내 주소",
	myWishlist: "찜 목록",
	myRmas: "애프터서비스",
	userCommission: "회원 수수료",
	commissionUsers: "회원 관계",
	loginOut: "로그아웃",
	orderId: "주문 번호",

	lookDetail: "상세 보기",
	saleService: "AS 신청",
	confirmReceivedGoods: "수령 확인",
	goPay: "결제 하기",
	cancelOrder: "주문 취소",

	orderDetail: "주문 상세",
	created_at: "생성 시간",
	status_format: "주문 상태",
	total_format: "주문 금액",
	payment_method_name: '결제 방식',
	shipping_method_name: '배송 방식',

	addressInfo: "주소 정보",
	name: "이름",
	address: "주소",
	payGoods: "주문 상품",

	sendCompany: "택배사",
	sendNum: "운송장 번호",
	updateTime: "업데이트 시간",
	memo: "메모",
	payOrderAddress: "청구지 주소",
	allOrder: "전체 주문",
	waitPay: "결제 대기",
	waitSend: "발송 대기",
	waitReceiving: "수령 대기",
	completed: "완료됨",
	confirm: "확인",
	tips: "알림",
	cancel: '취소',
	changeHeadImg: "프로필 사진 변경",
	uploadTit: "JPEG 또는 PNG 파일만 업로드. 권장 크기: 300 x 300",
	imgSizeTips: "프로필 사진은 2MB 이하만 가능!",
	imgTypeTips: "프로필 사진은 JPG/PNG 형식만 지원!",
	serviceType: "서비스 유형",
	returnNum: "반품/교환 수량",
	isOpend: "포장 개봉 여부",
	returnReason: "반품/교환 사유",
	yes: "예",
	no: "아니오",
	returnGoods: "반품",
	exchange: "교환",
	repair: "수리",
	reissue: "재발송",
	refund: "환불만",
	returnNumError: "반품/교환 수량을 입력하세요",

	oldPassword: "기존 비밀번호",
	newPassword: "새 비밀번호",
	confirmNewPassword: "새 비밀번호 확인",

	wishlist: "찜 삭제",
	look: "보기",
	opendPkg: "포장 개봉함",
	img: "이미지",
	afterSales: "AS 상세",

	balance: "사용 가능 잔액",
	waitAmount: "정산 대기 금액",
	withdrawaled: "출금 완료",
	withdrawal: "출금",
	allCommission: "총 수수료",
	startTime: "시작 시간",
	endTime: "종료 시간",
	search: "검색",

	rebateLevel: "리베이트 단계",
	CommissionRate: "수수료 비율",
	commission: "수수료",
	settlementStatus: "정산 상태",
	time: "시간",
	WithdrawalAmount: "출금 금액",
	peleaseSelect: "선택해 주세요",
	withdrawalUser: "출금 계좌",
	peleaseIpt: "내용을 입력하세요",
	submitSuccess: "제출 성공",
	shareLink: "공유 링크",
	superior: "직속 상급자",
	wu: "없음",
	subordinate: "하위 사용자",
	addTime: "가입 시간",
	userAccount: "계정",
	recommendationCode: "추천 코드",
	copySuccess: "복사 성공",
	subPay: "결제 제출",
	iptCardholder_Name: "카드 소유자 이름을 입력하세요",
	copy: "복사",

	"home": "홈",
	"categoriesPage": "카테고리",
	"brandsPage": "브랜드",
	"brandsPageList": "브랜드 상품",
	"productsPage": "상품",
	"wishlistPage": "내 찜목록",
	"accountPage": "내 주문",
	"cartsPage": "장바구니",
	"checkoutPage": "결제",
	"passwordPage": "비밀번호 변경",
	"editPage": "정보 수정",
	"addressesPage": "주소 수정",
	"rmasPage": "회원 관계",
	"commissionPage": "회원 수수료",
	"success_order_checkoutPage": "주문 결제",
	"page_categoriesPage": "글 카테고리",
	"userloginPage": "로그인",
	"pagesPage": "글",

	hotGoods: "인기 상품",
	newGoods: "신상품",
	visitGoods: "조회수 순위",
	allGoods: "전체 상품",
	evaluation: "리뷰",

	"first_name": "성",
	"first_nameError": "성을 입력해 주세요",
	"last_name": "이름",
	"last_nameError": "이름을 입력해 주세요",

	"comment": "콘텐츠",
	"noContent": "아직 댓글이 없습니다",
	"author": "작성자",
	"scoreNum": "평점",
	"commentTit": "댓글",
	send: "전송",

	noPayWay: "사용 가능한 결제 방법이 없습니다",
	noTransportation: "사용 가능한 배송 방법이 없습니다",
	
	"tkyouorder": "주문해 주셔서 감사합니다",
	  "orderDate": "주문 일자",
	  "ordeAmount": "주문 금액",
	  "paymentAddress": "결제 주소",
	  "zipCode": "우편번호",
	  customizationFee: "커스터마이징 비용"
}